import { render, staticRenderFns } from "./vehicle_defects.vue?vue&type=template&id=32797389&scoped=true&"
import script from "./vehicle_defects.vue?vue&type=script&lang=js&"
export * from "./vehicle_defects.vue?vue&type=script&lang=js&"
import style0 from "./vehicle_defects.vue?vue&type=style&index=0&id=32797389&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32797389",
  null
  
)

export default component.exports